/* ==========================================================================
   gp-sg.js — Geroprotect SG-Template v1 (shopgeroprotect.com)
   Namespaced gp- ; no external requests; idempotent (may be included by
   more than one section on the same page).
   ========================================================================== */
(function () {
  'use strict';

  if (window.gpSgInit) return;
  window.gpSgInit = true;

  (function gpKeepPlaying() {
    var v = document.querySelector('.gp-hero__video');
    if (!v) return;
    v.addEventListener('pause', function () {
      setTimeout(function () {
        var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (v.paused && !v.ended && v.dataset.gpCovered !== '1' && !rm && !document.hidden) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      }, 150);
    });
  })();


  (function gpVideoWatchdog() {
    var v = document.querySelector('.gp-hero__video');
    if (!v) return;
    var stepped = false;
    function stepDown(reason) {
      /* a slow-but-progressing load is healthy — only step down when the
         buffer is still EMPTY, and step to the lighter 720p file instead of
         re-requesting the same big one (load() aborts in-flight progress) */
      if (stepped) return;
      var coveredPause = v.dataset.gpCovered === '1';
      if (reason !== 'rebuffer' && (v.readyState >= 2 || (v.buffered && v.buffered.length > 0))) return;
      var alt = v.dataset.mobileMp4;
      if (!alt || (v.currentSrc || '').indexOf(alt.split('?')[0].split('/').pop()) !== -1) return;
      stepped = true;
      Array.prototype.slice.call(v.querySelectorAll('source')).forEach(function (s) {
        s.parentNode.removeChild(s);
      });
      var s = document.createElement('source');
      s.setAttribute('src', alt);
      s.setAttribute('type', 'video/mp4');
      v.appendChild(s);
      v.load();
      if (!coveredPause) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    v.addEventListener('error', function () { stepDown('error'); }, true);
    setTimeout(function () { stepDown('timeout'); }, 6000);
    /* connection too slow for 1080p: 3 rebuffers in the first 30s -> 720p */
    var waits = 0, born = Date.now();
    v.addEventListener('waiting', function () {
      if (Date.now() - born < 30000 && ++waits >= 3) stepDown('rebuffer');
    });
    /* whenever data becomes ready and nothing intentionally paused us, play —
       covers autoplay promises aborted by load()/source recovery */
    v.addEventListener('canplay', function () {
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (v.paused && v.dataset.gpCovered !== '1' && !rm) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  })();


  (function gpMobileSrcSwap() {
    var v = document.querySelector('.gp-hero__video');
    if (!v || !v.dataset.mobileMp4 || window.innerWidth >= 750) return;
    var srcs = Array.prototype.slice.call(v.querySelectorAll('source'));
    srcs.forEach(function (s) {
      if ((s.getAttribute('type') || '').indexOf('mp4') !== -1) s.setAttribute('src', v.dataset.mobileMp4);
      else s.parentNode.removeChild(s);
    });
    v.load();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  })();


  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------------
     i18n — strings for the switcher UI (data-i18n attributes).
     Source: work/copy/i18n.json. Client-side label swap only; full page
     translation ships when Shopify locales are published.
  ------------------------------------------------------------------ */
  var GP_I18N = {
    slogan_level_up: {
      en: 'Level up from the inside out.',
      ar: 'ارتقِ بنفسك من الداخل.',
      fr: "Évolue de l'intérieur.",
      de: 'Wachse von innen heraus.',
      es: 'Supérate desde dentro.'
    },
    slogan_move: {
      en: 'Move before time does.',
      ar: 'بادر قبل أن يسبقك العمر.',
      fr: 'Devance le temps.',
      de: 'Beweg dich, bevor die Zeit es tut.',
      es: 'Actúa antes que el tiempo.'
    },
    hero_cta: {
      en: 'Shop the Essentials',
      ar: 'تسوّق الأساسيات',
      fr: 'Acheter les Essentials',
      de: 'Essentials shoppen',
      es: 'Compra los Essentials'
    },
    shop_now: {
      en: 'Shop now',
      ar: 'تسوّق الآن',
      fr: 'Acheter maintenant',
      de: 'Jetzt shoppen',
      es: 'Compra ahora'
    },
    nav_formula: {
      en: 'Formula',
      ar: 'التركيبة',
      fr: 'Formule',
      de: 'Formel',
      es: 'Fórmula'
    },
    nav_shop: {
      en: 'Shop',
      ar: 'المتجر',
      fr: 'Boutique',
      de: 'Shop',
      es: 'Tienda'
    },
    nav_about: {
      en: 'About us',
      ar: 'من نحن',
      fr: 'À propos',
      de: 'Über uns',
      es: 'Sobre nosotros'
    },
    nav_science: {
      en: 'Science',
      ar: 'العلم',
      fr: 'Science',
      de: 'Wissenschaft',
      es: 'Ciencia'
    },
    nav_faq: {
      en: 'FAQ',
      ar: 'الأسئلة الشائعة',
      fr: 'FAQ',
      de: 'FAQ',
      es: 'Preguntas frecuentes'
    },
    add_to_cart: {
      en: 'Add to cart',
      ar: 'أضف إلى السلة',
      fr: 'Ajouter au panier',
      de: 'In den Warenkorb',
      es: 'Añadir al carrito'
    },
    email_us: {
      en: 'Email us',
      ar: 'راسلنا عبر البريد الإلكتروني',
      fr: 'Envoyer un email',
      de: 'E-Mail senden',
      es: 'Enviar email'
    },
    whatsapp_us: {
      en: 'WhatsApp us',
      ar: 'راسلنا عبر واتساب',
      fr: 'Écrire sur WhatsApp',
      de: 'Auf WhatsApp schreiben',
      es: 'Escribir por WhatsApp'
    },
    language: {
      en: 'Language',
      ar: 'اللغة',
      fr: 'Langue',
      de: 'Sprache',
      es: 'Idioma'
    },
    currency: {
      en: 'Currency',
      ar: 'العملة',
      fr: 'Devise',
      de: 'Währung',
      es: 'Moneda'
    },
    faq_full: {
      en: 'Frequently asked questions',
      ar: 'الأسئلة الشائعة',
      fr: 'Foire aux questions',
      de: 'Häufig gestellte Fragen',
      es: 'Preguntas frecuentes'
    },
    scroll_to_explore: {
      en: 'Scroll to explore',
      ar: 'مرِّر للاستكشاف',
      fr: 'Faites défiler pour explorer',
      de: 'Zum Erkunden scrollen',
      es: 'Desliza para explorar'
    }
  };

  var GP_LANGS = ['en', 'ar', 'fr', 'de', 'es'];

  function gpGetLang() {
    var stored;
    try {
      stored = window.localStorage.getItem('gp-lang');
    } catch (e) {
      stored = null;
    }
    if (stored && GP_LANGS.indexOf(stored) !== -1) return stored;
    var documentLang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    if (GP_LANGS.indexOf(documentLang) !== -1) return documentLang;
    return 'en';
  }

  function gpApplyLang(lang) {
    if (GP_LANGS.indexOf(lang) === -1) lang = 'en';
    var root = document.documentElement;
    if (root.dataset.gpOrigDir === undefined) root.dataset.gpOrigDir = root.getAttribute('dir') || 'ltr';
    root.setAttribute('dir', lang === 'ar' ? 'rtl' : root.dataset.gpOrigDir);
    root.setAttribute('data-gp-ui-lang', lang);
    /* For English keep the server-rendered copy (merchant may have edited it
       in the theme editor); only swap labels for the other languages. */
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      if (el.dataset.gpOrig === undefined) el.dataset.gpOrig = el.textContent;
      if (lang === 'en') {
        el.textContent = el.dataset.gpOrig;
        return;
      }
      var entry = GP_I18N[el.getAttribute('data-i18n')];
      if (entry && entry[lang]) el.textContent = entry[lang];
    });
    document.querySelectorAll('[data-i18n-aria]').forEach(function (el) {
      if (el.dataset.gpOrigAria === undefined) {
        el.dataset.gpOrigAria = el.getAttribute('aria-label') || '';
      }
      if (lang === 'en') {
        if (el.dataset.gpOrigAria) el.setAttribute('aria-label', el.dataset.gpOrigAria);
        return;
      }
      var entry = GP_I18N[el.getAttribute('data-i18n-aria')];
      if (entry && entry[lang]) el.setAttribute('aria-label', entry[lang]);
    });
    document.querySelectorAll('.gp-pill--lang [data-gp-lang-current]').forEach(function (el) {
      el.textContent = lang.toUpperCase();
    });
    document.querySelectorAll('.gp-pill__opt[data-gp-lang]').forEach(function (el) {
      el.classList.toggle('is-current', el.getAttribute('data-gp-lang') === lang);
    });
  }

  function gpSetLang(lang) {
    try {
      window.localStorage.setItem('gp-lang', lang);
    } catch (e) {
      /* private mode — ignore */
    }
    gpApplyLang(lang);
  }

  /* ------------------------------------------------------------------
     Smooth scroll helper
  ------------------------------------------------------------------ */
  function gpScrollTo(target) {
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  /* ------------------------------------------------------------------
     Hero pill rail — ferris wheel (desktop) / snap row cycle (mobile)
     Pills rotate through vertical slots every 3s; the center slot is
     "active" (glow + gold check). Hover/focus pauses; a click pauses 6s
     and smooth-scrolls to the pill's section. Reduced motion: static
     stack, highlight steps without movement.
  ------------------------------------------------------------------ */
  function gpInitHeroPills(hero) {
    var rail = hero.querySelector('.gp-hero__pills');
    if (!rail) return;

    var pills = Array.prototype.slice.call(rail.querySelectorAll('.gp-pill-nav'));
    var n = pills.length;
    if (!n) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var SLOT = 64; /* px between vertical slots */
    var WRAP_FADE_MS = 360;
    var center = Math.floor(n / 2);
    var slots = pills.map(function (_, i) { return i; });
    var mobileIndex = 0;
    var paused = false;
    var pauseUntil = 0;
    var wheelOn = false;

    function styleFor(slot) {
      var d = Math.abs(slot - center);
      var dir = slot < center ? 1 : -1; /* above the centre tilts back, below tilts forward */
      if (d === 0) return { scale: 1.08, opacity: 1, z: 0, rx: 0 };
      if (d === 1) return { scale: 1, opacity: 0.9, z: -46, rx: 16 * dir };
      return { scale: 0.94, opacity: 0.62, z: -110, rx: 30 * dir };
    }

    function applyPill(i) {
      var s = slots[i];
      var st = styleFor(s);
      var p = pills[i];
      p.style.transform = 'translateY(' + s * SLOT + 'px) translateZ(' + (st.z || 0) + 'px) rotateX(' + (st.rx || 0) + 'deg) scale(' + st.scale + ')';
      p.style.opacity = String(st.opacity);
      p.classList.toggle('gp-active', s === center);
    }

    function applyAll() {
      for (var i = 0; i < n; i++) applyPill(i);
    }

    function enableWheel() {
      if (wheelOn) return;
      /* measure a pill before switching to absolute positioning */
      var pillH = pills[0].offsetHeight || 48;
      rail.classList.add('gp-wheel');
      rail.style.height = (SLOT * (n - 1) + pillH) + 'px';
      wheelOn = true;
      applyAll();
    }

    function disableWheel() {
      if (!wheelOn && !rail.classList.contains('gp-wheel')) return;
      wheelOn = false;
      rail.classList.remove('gp-wheel');
      rail.style.height = '';
      pills.forEach(function (p) {
        p.style.transform = '';
        p.style.opacity = '';
      });
    }

    /* wrap-around pill (bottom -> top): fade out in place, teleport, fade in */
    function wrapAround(i) {
      var p = pills[i];
      p.classList.remove('gp-active');
      p.style.opacity = '0';
      window.setTimeout(function () {
        if (!wheelOn) { return; }
        var s = slots[i];
        var st = styleFor(s);
        p.classList.add('gp-no-trans');
        p.style.transform = 'translateY(' + s * SLOT + 'px) translateZ(' + (st.z || 0) + 'px) rotateX(' + (st.rx || 0) + 'deg) scale(' + st.scale + ')';
        /* double rAF instead of a forced style flush: let the no-trans jump
           commit in one frame, re-enable transitions the next (the pill is at
           opacity 0 throughout, so the extra frame is invisible) */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!wheelOn) { return; }
            p.classList.remove('gp-no-trans');
            p.style.opacity = String(st.opacity);
            p.classList.toggle('gp-active', s === center);
          });
        });
      }, WRAP_FADE_MS);
    }

    function rotate() {
      var wrapIdx = -1;
      var i;
      for (i = 0; i < n; i++) {
        if (slots[i] === n - 1) wrapIdx = i;
        slots[i] = (slots[i] + 1) % n;
      }
      for (i = 0; i < n; i++) {
        if (i === wrapIdx) wrapAround(i);
        else applyPill(i);
      }
    }

    function setActiveMobile(i) {
      pills.forEach(function (p, k) {
        p.classList.toggle('gp-active', k === i);
      });
    }

    function tick() {
      if (paused || Date.now() < pauseUntil) return;
      if (wheelOn) {
        rotate();
      } else {
        /* mobile snap row + reduced-motion stack: step the highlight only */
        mobileIndex = (mobileIndex + 1) % n;
        setActiveMobile(mobileIndex);
      }
    }

    function evalMode() {
      if (desktop.matches && !reducedMotion.matches) enableWheel();
      else disableWheel();
    }

    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('focusin', function () { paused = true; });
    rail.addEventListener('focusout', function () { paused = false; });

    if (desktop.addEventListener) desktop.addEventListener('change', evalMode);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', evalMode);

    pills.forEach(function (pill, i) {
      var main = pill.querySelector('.gp-pill-nav__main');
      if (!main) return;
      main.addEventListener('click', function () {
        pauseUntil = Date.now() + 6000;
        if (!wheelOn) {
          mobileIndex = i;
          setActiveMobile(i);
        }
        var anchor = pill.getAttribute('data-gp-anchor');
        if (anchor) gpScrollTo(document.getElementById(anchor));
      });
    });

    evalMode();
    if (!wheelOn) setActiveMobile(mobileIndex);
    window.setInterval(tick, 3000);
  }

  /* ------------------------------------------------------------------
     Slide-over depth: as the sheet covers the pinned hero, the hero
     content recedes (scale -> .96, opacity -> .6). rAF-throttled,
     transform/opacity only, skipped for reduced motion.
  ------------------------------------------------------------------ */
  function gpInitSlideOver(hero) {
    var inner = hero.querySelector('.gp-hero__inner');
    if (!inner) return;
    var video = hero.querySelector('.gp-hero__video');
    var ticking = false;
    var heroH = hero.offsetHeight || 1;
    var videoCovered = false;

    /* cache the hero height so the scroll rAF never reads layout */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        heroH = hero.offsetHeight || 1;
      }).observe(hero);
    } else {
      window.addEventListener('resize', function () {
        heroH = hero.offsetHeight || 1;
      });
    }

    function update() {
      ticking = false;
      var p = Math.min(1, Math.max(0, window.scrollY / heroH));

      /* battery + decode: stop the film once the sheet fully covers the
         pinned hero. (An IntersectionObserver cannot detect this — the
         sticky hero never geometrically leaves the viewport, it only gets
         painted over — so the same scroll progress drives it.) */
      if (video) {
        var covered = p >= 1;
        if (covered !== videoCovered) {
          videoCovered = covered;
          if (covered) {
            /* flag the deliberate pause so gpVideoWatchdog never mistakes it
               for a stalled video and force-replays it under the sheet */
            video.dataset.gpCovered = '1';
            video.pause();
          } else {
            delete video.dataset.gpCovered;
            if (!reducedMotion.matches) {
              var pl = video.play();
              if (pl && pl.catch) pl.catch(function () {});
            }
          }
        }
      }

      if (reducedMotion.matches) return;
      inner.style.transform = 'scale(' + (1 - 0.04 * p).toFixed(4) + ')';
      inner.style.opacity = (1 - 0.4 * p).toFixed(3);
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function () {
        if (reducedMotion.matches) {
          inner.style.transform = '';
          inner.style.opacity = '';
        }
      });
    }

    update();
  }

  /* ------------------------------------------------------------------
     Formula system rows — accordion (single open per card, smooth
     height). First row opens on desktop for discoverability.
  ------------------------------------------------------------------ */
  function gpInitFormula(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.gp-formula__card'));

    function panelOf(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }

    /* grid-rows accordion (see gp-sg.css): class toggle only, no height
       measurement, no forced reflow */
    function close(btn) {
      btn.setAttribute('aria-expanded', 'false');
      var panel = panelOf(btn);
      if (panel) panel.classList.remove('gp-open');
    }

    function open(btn) {
      btn.setAttribute('aria-expanded', 'true');
      var panel = panelOf(btn);
      if (panel) panel.classList.add('gp-open');
    }

    cards.forEach(function (card) {
      var toggles = Array.prototype.slice.call(card.querySelectorAll('.gp-formula__system-toggle'));

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          toggles.forEach(close);
          if (!isOpen) open(btn);
        });
      });

      if (toggles.length && window.matchMedia('(min-width: 900px)').matches) {
        open(toggles[0]);
      }
    });
    /* no resize handler needed: the 0fr/1fr grid track resizes with content */
  }

  /* ------------------------------------------------------------------
     Hero scroll cue → next section
  ------------------------------------------------------------------ */
  function gpInitScrollCue(hero) {
    var cue = hero.querySelector('.gp-hero__scroll-cue');
    if (!cue) return;
    cue.addEventListener('click', function () {
      var shopifySection = hero.closest('.shopify-section') || hero;
      var next = shopifySection.nextElementSibling;
      if (next) gpScrollTo(next);
    });
  }

  /* ------------------------------------------------------------------
     FAQ accordion — single open, animated height
  ------------------------------------------------------------------ */
  function gpInitFaq(root) {
    var questions = Array.prototype.slice.call(root.querySelectorAll('.gp-faq__q'));

    /* grid-rows accordion (see gp-sg.css): class toggle only, no height
       measurement, no forced reflow, no resize handler */
    function close(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.classList.remove('gp-open');
    }

    function open(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.classList.add('gp-open');
    }

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        questions.forEach(close);
        if (!isOpen) open(btn);
      });
    });
  }

  /* ------------------------------------------------------------------
     Header pill dropdowns (fallback language menu, unpublished locales)
  ------------------------------------------------------------------ */
  function gpInitHeaderPills() {
    document.querySelectorAll('.gp-pill--dd').forEach(function (dd) {
      document.addEventListener('click', function (e) {
        if (dd.hasAttribute('open') && !dd.contains(e.target)) dd.removeAttribute('open');
      });

      dd.querySelectorAll('.gp-pill__opt[data-gp-lang]').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault(); /* locale not published — label swap only */
          gpSetLang(opt.getAttribute('data-gp-lang'));
          dd.removeAttribute('open');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function gpBoot() {
    document.querySelectorAll('.gp-hero').forEach(function (hero) {
      gpInitHeroPills(hero);
      gpInitScrollCue(hero);
      gpInitSlideOver(hero);
    });
    document.querySelectorAll('.gp-formula').forEach(gpInitFormula);
    document.querySelectorAll('.gp-faq').forEach(gpInitFaq);
    gpInitHeaderPills();
    gpApplyLang(gpGetLang());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gpBoot);
  } else {
    gpBoot();
  }
})();
